import React, { useState } from 'react';
import '../css/InvestorsPage.css'
import Footer from '../Components/Footer'

const InvestorsPage = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email_address: '',
    investment_interest: '',
    investor_type: 'individual',
    organization: '',
    investment_amount_range: '',
    message: '',
    phone_number: '',
    linkedin_profile: '',
    previous_investments: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // INVESTMENT INQUIRY HANDLER - Connected to Django Backend
const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Validate message length (backend requires 50+ characters)
      if (formData.message.trim().length < 50) {
        alert('Please provide more details about your investment interest (at least 50 characters)');
        setIsSubmitting(false);
        return;
      }

      // Clean and validate data
      const submitData = {
        full_name: formData.full_name.trim(),
        email_address: formData.email_address.trim(),
        investment_interest: formData.investment_interest,
        investor_type: formData.investor_type,
        organization: formData.organization.trim() || '',
        investment_amount_range: formData.investment_amount_range.trim() || '',
        message: formData.message.trim(),
        phone_number: formData.phone_number.trim() || '',
        linkedin_profile: formData.linkedin_profile.trim() || '',
        previous_investments: formData.previous_investments.trim() || ''
      };

      console.log('Investment Inquiry Data:', submitData);

      const response = await fetch('http://127.0.0.1:8000/api/contact/investment-inquiry/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submitData)
      });

      const data = await response.json();

      if (response.ok) {
        console.log('Success:', data);
        alert('Thank you for your interest! We will be in touch soon.');
        
        // Reset form
        setFormData({
          full_name: '',
          email_address: '',
          investment_interest: '',
          investor_type: 'individual',
          organization: '',
          investment_amount_range: '',
          message: '',
          phone_number: '',
          linkedin_profile: '',
          previous_investments: ''
        });
      } else {
        console.error('Error:', data);
        // Handle specific validation errors
        if (data.message) {
          alert('Message Error: ' + data.message[0]);
        } else if (data.email_address) {
          alert('Email Error: ' + data.email_address[0]);
        } else if (data.full_name) {
          alert('Name Error: ' + data.full_name[0]);
        } else {
          alert('Error submitting investment inquiry: ' + (data.error || JSON.stringify(data)));
        }
      }

    } catch (error) {
      console.error('Network error:', error);
      alert('Network error. Please check your connection and try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const milestones = [
    {
      metric: '10K+',
      description: 'Creators Onboarded',
      icon: '👥'
    },
    {
      metric: '250+',
      description: 'Active Brand Campaigns',
      icon: '🚀'
    },
    {
      metric: '15+',
      description: 'Strategic Partnerships',
      icon: '🤝'
    },
    {
      metric: '85%',
      description: 'Platform Engagement Rate',
      icon: '📈'
    }
  ];

  const testimonials = [
    {
      name: 'Sarah Chen',
      title: 'Managing Partner, Future Ventures',
      quote: 'Red Fibre is uniquely positioned to capture the massive shift toward creator-driven commerce. Their AI-powered approach to brand building is exactly what the market needs.'
    },
    {
      name: 'Marcus Rodriguez',
      title: 'Former VP of Growth, TikTok',
      quote: 'The team\'s deep understanding of creator needs combined with their technical execution makes Red Fibre a standout investment opportunity in the creator economy space.'
    }
  ];

  return (
    <div className="investor-investors-page">
      {/* Hero Section */}
      <section className="investor-hero">
        <div className="investor-container">
          <div className="investor-hero-content">
            <h1 className="investor-hero-title">Fueling the Future of Creativity.</h1>
            <p className="investor-hero-subtitle">
              We're scaling the creator economy by helping creators and brands unlock their identity, 
              build with AI, and create lasting creative capital that drives the IP-driven future.
            </p>
            <div className="investor-hero-actions">
              <a href="/RedFibre_PitchDeck.pdf" className="investor-btn investor-btn-primary" download>
                Download Pitch Deck
              </a>
              <a href="#contact" className="investor-btn investor-btn-secondary">
                Connect with Us
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Invest Section */}
      <section className="investor-why-invest">
        <div className="investor-container">
          <h2 className="investor-section-title">Why Invest in Red Fibre</h2>
          <div className="investor-invest-grid">
            <div className="investor-invest-card">
              <div className="investor-invest-icon">📊</div>
              <h3>Explosive Market Growth</h3>
              <p>The creator economy is projected to reach $480B by 2027. We're capturing this massive opportunity with our comprehensive platform that addresses real creator pain points.</p>
            </div>
            <div className="investor-invest-card">
              <div className="investor-invest-icon">🧠</div>
              <h3>Proven Execution Team</h3>
              <p>Our founding team combines deep creator economy expertise with technical excellence, having previously scaled products at leading tech companies and creative agencies.</p>
            </div>
            <div className="investor-invest-card">
              <div className="investor-invest-icon">🤖</div>
              <h3>Proprietary AI Ecosystem</h3>
              <p>Our AI-powered branding and identity tools create unique competitive advantages, enabling creators to build authentic brands at scale with unprecedented efficiency.</p>
            </div>
            <div className="investor-invest-card">
              <div className="investor-invest-icon">🎯</div>
              <h3>Strong Early Traction</h3>
              <p>Real-world validation with active creator campaigns, strategic partnerships, and high platform engagement demonstrating product-market fit in a growing segment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Milestones Section */}
      <section className="investor-milestones">
        <div className="investor-container">
          <h2 className="investor-section-title">Milestones & Traction</h2>
          <div className="investor-milestones-grid">
            {milestones.map((milestone, index) => (
              <div key={index} className="investor-milestone-card">
                <div className="investor-milestone-icon">{milestone.icon}</div>
                <div className="investor-milestone-metric">{milestone.metric}</div>
                <div className="investor-milestone-description">{milestone.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="investor-testimonials">
        <div className="investor-container">
          <h2 className="investor-section-title">Investor Testimonials</h2>
          <div className="investor-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="investor-testimonial-card">
                <div className="investor-testimonial-quote">"{testimonial.quote}"</div>
                <div className="investor-testimonial-author">
                  <div className="investor-author-name">{testimonial.name}</div>
                  <div className="investor-author-title">{testimonial.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section id="contact" className="investor-contact">
        <div className="investor-container">
          <h2 className="investor-section-title">Ready to Join Our Journey?</h2>
          <p className="investor-contact-subtitle">
            Get in touch to learn more about investment opportunities and our vision for the future of creativity.
          </p>
          <form className="investor-contact-form" onSubmit={handleSubmit}>
            <div className="investor-form-row">
              <div className="investor-form-group">
                <label htmlFor="full_name">Full Name *</label>
                <input
                  type="text"
                  id="full_name"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="investor-form-group">
                <label htmlFor="email_address">Email Address *</label>
                <input
                  type="email"
                  id="email_address"
                  name="email_address"
                  value={formData.email_address}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="investor-form-row">
              <div className="investor-form-group">
                <label htmlFor="investment_interest">Investment Interest *</label>
                <select
                  id="investment_interest"
                  name="investment_interest"
                  value={formData.investment_interest}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select your interest level</option>
                  <option value="casual">Casual Interest</option>
                  <option value="serious">Serious Consideration</option>
                  <option value="ready">Ready to Invest</option>
                  <option value="strategic">Strategic Partnership</option>
                  <option value="acquisition">Acquisition Interest</option>
                </select>
              </div>
              <div className="investor-form-group">
                <label htmlFor="investor_type">Investor Type</label>
                <select
                  id="investor_type"
                  name="investor_type"
                  value={formData.investor_type}
                  onChange={handleInputChange}
                >
                  <option value="individual">Individual Investor</option>
                  <option value="angel">Angel Investor</option>
                  <option value="vc_fund">Venture Capital Fund</option>
                  <option value="private_equity">Private Equity</option>
                  <option value="corporate">Corporate Investor</option>
                  <option value="family_office">Family Office</option>
                  <option value="government">Government Entity</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            <div className="investor-form-row">
              <div className="investor-form-group">
                <label htmlFor="organization">Organization</label>
                <input
                  type="text"
                  id="organization"
                  name="organization"
                  value={formData.organization}
                  onChange={handleInputChange}
                  placeholder="Your investment firm/company"
                />
              </div>
              <div className="investor-form-group">
                <label htmlFor="investment_amount_range">Investment Range</label>
                <input
                  type="text"
                  id="investment_amount_range"
                  name="investment_amount_range"
                  value={formData.investment_amount_range}
                  onChange={handleInputChange}
                  placeholder="e.g., $25K-$100K, $500K+, to be discussed"
                />
              </div>
            </div>

            <div className="investor-form-row">
              <div className="investor-form-group">
                <label htmlFor="phone_number">Phone Number</label>
                <input
                  type="tel"
                  id="phone_number"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleInputChange}
                  placeholder="Your contact number"
                />
              </div>
              <div className="investor-form-group">
                <label htmlFor="linkedin_profile">LinkedIn Profile</label>
                <input
                  type="url"
                  id="linkedin_profile"
                  name="linkedin_profile"
                  value={formData.linkedin_profile}
                  onChange={handleInputChange}
                  placeholder="https://linkedin.com/in/yourprofile"
                />
              </div>
            </div>

            <div className="investor-form-group">
              <label htmlFor="previous_investments">Previous Investments</label>
              <textarea
                id="previous_investments"
                name="previous_investments"
                value={formData.previous_investments}
                onChange={handleInputChange}
                rows="3"
                placeholder="Tell us about your investment experience, portfolio companies, or focus areas..."
              ></textarea>
            </div>

            <div className="investor-form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                rows="5"
                placeholder="Tell us about your investment focus, portfolio, or any specific questions you have about Red Fibre..."
                required
              ></textarea>
            </div>
            
            <button type="submit" className="investor-btn investor-btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Request a Call'}
            </button>
          </form>
        </div>
      </section>
      
      <div>
        <Footer/>
      </div>
    </div>
  );
};

export default InvestorsPage;